import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { AdministrationAbstract } from '@main-application/administration/abstract/administration-abstract';
import { RestSpaceTemplateModel } from '@main-application/space-template/models/rest-space-template-model.interface';
import { loadAllSpaceTemplates } from '@main-application/space-template/store/space-template.actions';
import { selectSpaceTemplates } from '@main-application/space-template/store/space-template.selectors';
import { AppRoutes } from '@shared/constants/app-routes.const';
import { HelpRouterService } from '@shared/services/help-router.service';
import { RestTemplateModel } from '@template/models/rest-template-model.interface';
import { TEMPLATE_VIEWS } from '@template/models/template-views';
import { DialogResult } from '@ui-components/modals/config/dialog-result.enum';

@UntilDestroy()
@Component({
  selector: 'app-space-template-modal',
  templateUrl: './space-template-modal.component.html',
  styleUrls: ['./space-template-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SpaceTemplateModalComponent extends AdministrationAbstract implements OnInit, OnDestroy {
  displayedColumns = ['name', 'isTurboMode', 'steps', 'actions'];
  dataSource$: Observable<RestSpaceTemplateModel[]>;

  constructor(
    protected cdr: ChangeDetectorRef,
    protected router: Router,
    protected store: Store<{}>,
    public dialogRef: MatDialogRef<SpaceTemplateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public templateDetails: RestTemplateModel,
    private helpRouterService: HelpRouterService
  ) {
    super(cdr, store);
  }

  ngOnInit(): void {
    this.dataSource$ = this.store.select(selectSpaceTemplates).pipe(
      untilDestroyed(this),
      tap(list => {
        if (!list) {
          this.store.dispatch(loadAllSpaceTemplates());
        }
      }),
      filter(list => !!list)
    );
  }

  close(result: DialogResult = DialogResult.Fail) {
    this.dialogRef.close(result);
  }

  selectSpaceTemplate(spaceTemplate: RestSpaceTemplateModel) {
    this.router
      .navigate([AppRoutes.SETTINGS_TEMPLATE, this.templateDetails.id, TEMPLATE_VIEWS.AREA, TEMPLATE_VIEWS.NEW_AREA], {
        queryParams: { spaceTemplateId: spaceTemplate.id },
        queryParamsHandling: 'merge',
      })
      .then(() => this.close());
  }

  ngOnDestroy(): void {}
}
